/**
 * Utility functions for date formatting
 */

/**
 * Format a date string to German locale with short month name (DD. MMM YYYY)
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date string or 'N/A' if invalid
 */
export const formatDate = (dateString) => {
	if (!dateString) return 'N/A';

	try {
		return new Date(dateString).toLocaleDateString('de-DE', {
			day: '2-digit',
			month: 'short',
			year: 'numeric',
		});
	} catch {
		return 'N/A';
	}
};

export const formatDateWithTime = (dateString) => {
	if (!dateString) return 'N/A';

	try {
		return new Date(dateString).toLocaleDateString('de-DE', {
			hour: '2-digit',
			minute: '2-digit',
			day: '2-digit',
			month: 'short',
			year: 'numeric',
		});
	} catch {
		return 'N/A';
	}
};
